var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-demo",
      attrs: {
        router: true,
        mode: _vm.mmode,
        "background-color": "#545c64",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
      },
    },
    [
      _c("el-menu-item", { attrs: { index: "/" } }, [
        _c("i", { staticClass: "el-icon-pie-chart" }),
      ]),
      _c("el-menu-item", { attrs: { index: "/cars" } }, [
        _vm._v(" Автомобили "),
      ]),
      _c("el-menu-item", { attrs: { index: "/tuning" } }, [
        _vm._v(" Тюнинг/Экстерьер "),
      ]),
      _c(
        "el-menu-item",
        {
          attrs: { index: "/" },
          on: {
            click: function ($event) {
              return _vm.logout("/login")
            },
          },
        },
        [_c("i", { staticClass: "el-icon-right" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }